import { AccountInfo } from '@azure/msal-browser';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from '../../services/config.service';
import { LoginService } from '../../services/login.service';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  showSpinner: boolean = false;
  subscriptions: Subscription = new Subscription();

  private isOpenId: boolean
  constructor(
    private router: Router,
    private loginService: LoginService,
    private readonly configService: ConfigService
  ) {
    this.isOpenId = this.configService.configData.authenticationType == 1;
  }

  ngOnInit(): void {
    if (!this.isOpenId) {
      this.goHome();
    }

    this.subscriptions.add(this.loginService.employeeLoggedIn.subscribe(c => {
      this.goHome();
      this.showSpinner = false;
    }, error => {
      this.showSpinner = false;
      console.error(error);
    }));
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  async login() {
    this.showSpinner = true;
    await this.loginService.login();
  }

  goHome() {
    this.router.navigate(['/']);
  }

  get account(): AccountInfo {
    return this.loginService.getAccount();
  }

}
